export const SHOW_ATTENDANCE_NAVIGATION = false;
